import { render, staticRenderFns } from "./Regions.vue?vue&type=template&id=03a4a366&scoped=true&"
import script from "./Regions.vue?vue&type=script&lang=js&"
export * from "./Regions.vue?vue&type=script&lang=js&"
import style0 from "./Regions.vue?vue&type=style&index=0&id=03a4a366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a4a366",
  null
  
)

export default component.exports